import React, { PropTypes, Component } from "react";

import { NitroBadge } from "nitro-components";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as actions from "./actions";

import styled from "styled-components";

import * as routes from "../../../routes/const";

import NotificationPopUp from "./NotificationPopUp";

const Notifications = styled.div`
  position: relative;
`;

const NotificationButton = styled.button`
  background: none;
  border: 0;
  cursor: pointer;
  outline: 0;
  padding: 0;
`;

class NotificationBadge extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      popUpOpen: false
    };
  }

  componentWillMount() {
    this.getNotifications();
  }

  /** componentDidUpdate(prevProps) {
    if (
      prevProps.deleteComplete !== this.props.deleteComplete &&
      !this.props.deleteInProgress
    ) {
      this.getNotifications();
      this.setState({
        resetConfirm: true
      });
      this.props.actions.updateOtherNotifications(true);
    }
  }**/

  getNotifications() {
    this.props.actions.getNotifications();
  }

  closeNotification = () => {
    this.setState({ popUpOpen: false });
  };

  toggleNotification = () => {
    this.setState({
      popUpOpen: !this.state.popUpOpen,
    });
  };

  gotoNotification = () => {
    this.toggleNotification();
    this.context.router.push(routes.NOTIFICATION_CENTER);
  };

  // On delete refresh the global notifications
  onDelete = data => {
    this.getNotifications();

    //this.props.actions.deleteNotification(data);
    /** NotificationApi.deleteNotification(data)
      .then(data => {
        if (data) {
          this.getNotifications();
          this.setState({
            resetConfirm: true
          });
        } else {
          console.log("NotificationApi.deleteNotification data error");
        }
      })
      .catch(error => {
        console.log("NotificationApi.deleteNotification error", error);
      });**/
  };

  render() {
    const { data, fetchingNotifications } = this.props;
    return (
      <Notifications>
        <NotificationButton onClick={this.toggleNotification}>
          <NitroBadge
            variant="notification"
            label={data && data.length > 0 ? data.length : ""}
            size={16}
            align="center"
            icon="notifications"
            iconVariant="white"
            bold
          />
        </NotificationButton>
        {this.state.popUpOpen &&
          <NotificationPopUp
            action={this.gotoNotification}
            data={data}
            closeNotification={this.closeNotification}
            fetchingNotifications={fetchingNotifications}
            onNotificationDelete={this.onDelete}
          />
        }
      </Notifications>
    );
  }
}

NotificationBadge.propTypes = {
  actions: PropTypes.object,
  data: PropTypes.array,
  deleteComplete: PropTypes.bool,
  deleteInProgress: PropTypes.bool,
  fetchingNotifications: PropTypes.bool
};

NotificationBadge.contextTypes = {
  router: PropTypes.object
};

const mapStateToProps = state => ({
  data: state.globalNotification.notifications,
  fetchingNotifications: state.globalNotification.fetchingNotifications,
  deleteInProgress: state.globalNotification.deleteInProgress,
  deleteComplete: state.globalNotification.deleteComplete
});

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationBadge);



// WEBPACK FOOTER //
// ./src/features/common/GlobalNotification/NotificationBadge.js